import { render, staticRenderFns } from "./CommonList.vue?vue&type=template&id=319fcc94&scoped=true"
import script from "./CommonList.vue?vue&type=script&lang=js"
export * from "./CommonList.vue?vue&type=script&lang=js"
import style0 from "./CommonList.vue?vue&type=style&index=0&id=319fcc94&prod&lang=less&scoped=true"
import style1 from "./CommonList.vue?vue&type=style&index=1&id=319fcc94&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319fcc94",
  null
  
)

export default component.exports